import {RoomCall} from "@/core/api/room.call.api";
import { startState } from "../../../lib/gooroomee/sharenote/codemirror/5.17.0/codemirror";

export default {
    // // p2p
    // getUserVideoStream: ({ dispatch, commit, getters, rootGetters }) => ({userId}) => {
    //     const stream = RoomCall.getUserVideoStream({userId});
    //     return stream;
    // },
    // getUserScreenStream: ({ dispatch, commit, getters, rootGetters }) => ({userId}) => {
    //     const stream = RoomCall.getUserSecondStream({userId});
    //     return stream;
    // },

    roomCall: function(state) {
        return state.roomCall;
    },
    requestUnmute: function(state) {
        return state.roomCall.requestUnmute;
    },
    userGestureInit: function(state) {
        return state.roomCall.userGestureInit;
    },
    showConnectionStats: function(state){
        return state.showConnectionStats;
    },
    // mixing
    mixerConnectionStats: function(state, getters, rootState, rootGetters){
        return state.mixerConnectionStats;
    },
    currentVideoLayout: (state) => {
        if(state.roomCall.callType === 'p2p'){
            return 'auto';
        }
        return state.roomCall.mixingLayoutData?.secondStream?.layoutType || state.roomCall.videoLayout;
    },
    currentGridVideoLayout: (state) => {
        return state.roomCall.mixingLayoutData?.gridLayoutType
    },
    getRoomCallMixingLayoutData: (state) => {
        return state.roomCall.mixingLayoutData;
    },
    getRoomCallMixingChannelUserMap: (state, getters, rootState, rootGetters) => (userId) => {
        const mixingUserMap = state.roomCall.mixingLayoutData?.channelUserMap
        if (!userId) {
            return mixingUserMap;
        }
        return mixingUserMap.get(userId);
    },
    getRoomCallMixingChannelRtspUser: (state, getters, rootState, rootGetters) => (userId)=> {
        const value = getters.getRoomCallMixingChannelUserMap(userId)
        if (value?.type === 'rtsp') {
            return userId
        }
        return null;
    },
    getRoomCallMixingChannelRtspUserList: (state, getters, rootState, rootGetters) => {
        let userList = []
        const userMap = getters.getRoomCallMixingChannelUserMap()
        if (userMap) {
            for (const [key, value] of userMap) {
                if (value?.type === 'rtsp') {
                    userList.push({ userId: key })
                }
            }
        }
        return userList;
    },
    roomCallVideoLayoutCount: (state, getters, rootState, rootGetters) => {
        return getters.currentVideoLayout.slice(-5, -3);
    },
    pageInfo: (state, getters) => {
        return getters.getRoomCallMixingLayoutData?.secondStream?.pageInfo || getters.getRoomCallMixingLayoutData?.pageInfo;
    },

    callType: function(state){
        return state.roomCall.callType;
    },
    isP2PCallType: function(state, getters){
        return getters.callType === 'p2p';
    },
    isMixingCallType: function(state, getters){
        return getters.callType === 'mixing';
    },
    isMixerSFUCallType: function(state, getters){
        return getters.callType === 'mixer-sfu';
    },
    currentWebinarType: function(state, getters){
        return state.roomCall.webinarType || 'none';
    },
    isWebinar: function(state, getters, rootState, rootGetters) {
        return getters.currentWebinarType !== 'none';
    },
    isWebinarLive: function(state, getters, rootState, rootGetters) {
        return state.roomCall.webinarType === 'live';
    },
    isWebinarWall: function(state, getters, rootState, rootGetters) {
        return state.roomCall.webinarType === 'wall';
    },
    selectedWallModeTargetScreenType: function (state, getters, rootState, rootGetters) {
        let wallModeTargetScreenType = 'grid';
        const mixingLayoutData = state.roomCall.mixingLayoutData;
        if (!mixingLayoutData?.gridLayoutType) {
            return wallModeTargetScreenType;
        }
        if (mixingLayoutData.gridLayoutType !== mixingLayoutData.layoutType) {
            wallModeTargetScreenType = 'speaker';
        }
        return wallModeTargetScreenType;
    },
    isMatchedGridAndCommonLayoutType: function (state, getters, rootState, rootGetters) {
        const mixingLayoutData = state.roomCall.mixingLayoutData;
        return mixingLayoutData?.gridLayoutType === mixingLayoutData.layoutType
    }
}
